import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

export const INITIAL_STATE = Immutable({
  isLoading: false,
  successMessage: null,
  errorMessage: null,
  personTags: [],
  totalElements: 0,
});

const { Types, Creators } = createActions({
  getPersonTagsRequest: ['personId', 'customerId', 'pageParams'],
  getPersonTagsRequestSuccess: ['personTags', 'totalElements'],
  getPersonTagsRequestFailure: ['errorMessage'],

  createPersonTagRequest: ['tagInfos', 'personId', 'customerId', 'pageParams', 'useHID'],
  createPersonTagRequestSuccess: ['personTags', 'totalElements', 'successMessage'],
  createPersonTagRequestFailure: ['errorMessage'],

  editPersonTagRequest: ['tagId', 'tagInfos', 'personId', 'customerId', 'pageParams'],
  editPersonTagRequestSuccess: ['personTags', 'totalElements', 'successMessage'],
  editPersonTagRequestFailure: ['errorMessage'],

  deletePersonTagRequest: ['tagId', 'personId', 'customerId', 'pageParams'],
  deletePersonTagRequestSuccess: ['personTags', 'totalElements', 'successMessage'],
  deletePersonTagRequestFailure: ['errorMessage'],

  activateTagRequest: ['tagInfos', 'personId', 'customerId'],
  activateTagRequestSuccess: ['successMessage'],
  activateTagRequestFailure: ['errorMessage'],

  resetTags: null,
});

export const getPersonTagsRequest = (state) =>
  state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const getPersonTagsRequestSuccess = (state, { personTags, totalElements }) =>
  state.merge({ isLoading: false, personTags, totalElements });
export const getPersonTagsRequestFailure = (state, { errorMessage }) => state.merge({ isLoading: false, errorMessage });

export const createPersonTagRequest = (state) =>
  state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const createPersonTagRequestSuccess = (state, { personTags, totalElements, successMessage }) =>
  state.merge({ isLoading: false, personTags, totalElements, successMessage });
export const createPersonTagRequestFailure = (state, { errorMessage }) =>
  state.merge({ isLoading: false, errorMessage });

export const editPersonTagRequest = (state) =>
  state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const editPersonTagRequestSuccess = (state, { personTags, totalElements, successMessage }) =>
  state.merge({ isLoading: false, personTags, totalElements, successMessage });
export const editPersonTagRequestFailure = (state, { errorMessage }) => state.merge({ isLoading: false, errorMessage });

export const deletePersonTagRequest = (state) =>
  state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const deletePersonTagRequestSuccess = (state, { personTags, totalElements, successMessage }) =>
  state.merge({ isLoading: false, personTags, totalElements, successMessage });
export const deletePersonTagRequestFailure = (state, { errorMessage }) =>
  state.merge({ isLoading: false, errorMessage });

export const activateTagRequest = (state) => state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const activateTagRequestSuccess = (state, { successMessage }) =>
  state.merge({ isLoading: false, successMessage });
export const activateTagRequestFailure = (state, { errorMessage }) => state.merge({ isLoading: false, errorMessage });

export const resetTags = (state) => state.merge({ personTags: [], totalElements: 0 });

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_PERSON_TAGS_REQUEST]: getPersonTagsRequest,
  [Types.GET_PERSON_TAGS_REQUEST_SUCCESS]: getPersonTagsRequestSuccess,
  [Types.GET_PERSON_TAGS_REQUEST_FAILURE]: getPersonTagsRequestFailure,

  [Types.CREATE_PERSON_TAG_REQUEST]: createPersonTagRequest,
  [Types.CREATE_PERSON_TAG_REQUEST_SUCCESS]: createPersonTagRequestSuccess,
  [Types.CREATE_PERSON_TAG_REQUEST_FAILURE]: createPersonTagRequestFailure,

  [Types.EDIT_PERSON_TAG_REQUEST]: editPersonTagRequest,
  [Types.EDIT_PERSON_TAG_REQUEST_SUCCESS]: editPersonTagRequestSuccess,
  [Types.EDIT_PERSON_TAG_REQUEST_FAILURE]: editPersonTagRequestFailure,

  [Types.DELETE_PERSON_TAG_REQUEST]: deletePersonTagRequest,
  [Types.DELETE_PERSON_TAG_REQUEST_SUCCESS]: deletePersonTagRequestSuccess,
  [Types.DELETE_PERSON_TAG_REQUEST_FAILURE]: deletePersonTagRequestFailure,

  [Types.ACTIVATE_TAG_REQUEST]: activateTagRequest,
  [Types.ACTIVATE_TAG_REQUEST_SUCCESS]: activateTagRequestSuccess,
  [Types.ACTIVATE_TAG_REQUEST_FAILURE]: activateTagRequestFailure,

  [Types.RESET_TAGS]: resetTags,
});

export const TagsTypes = Types;
export default Creators;
